/* global Sys, Services */
Sys.ns("Services");

/**
 * The Custom Message Service.
 *
 * @class Services.CustomMessage
 * @extends Services.Base
 */
Services.CustomMessage = {
    constructor: function() {
        Services.CustomMessage.superclass.constructor.apply(this, arguments);
    },

    /**
     * Shows the message.
     *
     * @param {Object} config The message config.
     * @param {string} config.id The message id.
     * @param {string} config.title The message title.
     * @param {string} config.text The message text.
     * @param {Object[]} config.buttons Array of button configurations on the form { text : {String}, action (optional) : {Function}, scope (defaults to window) : {Object} }.
     * @returns {void}
     */
    show: function(config) {
        this.observable.fireEvent("request:customMessages.showDialog", config);
    },

    /**
     * Removes the message.
     *
     * @param {string} id The message id.
     * @returns {void}
     */
    remove: function(id) {
        this.observable.fireEvent("request:customMessages.removeDialog", id);
        this.observable.fireEvent("notify:customMessages.messagesClosed");
    }
};

Services.CustomMessage = Sys.extend(
    Services.Base,
    Services.CustomMessage,
    "Services.CustomMessage"
);
